<template>
  <v-app id="inspire">
    <v-app-bar
      app
      color="white"
      flat      
    >
    <v-app-bar-nav-icon  class="hidden-md-and-up" @click="sidebar = !sidebar"></v-app-bar-nav-icon>
    <v-navigation-drawer v-model="sidebar" app hide-overlay temporary>
        <v-list>
          <v-list-item v-for="(item, i) in menuItems" exact :key="i" :to="item.path">{{item.title}}</v-list-item>
        </v-list>
      </v-navigation-drawer>
    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn :to="{name: 'Quienes-somos'}" text>
        Who we are
      </v-btn>

      <v-divider
        inset
        vertical
      ></v-divider>

      <v-btn :to="{name: 'Filosofia'}" text>
        Philosophy
      </v-btn>

      <v-divider
        inset
        vertical
      ></v-divider>

      <v-btn :to="{name: 'Servicios'}" text>
        Services
      </v-btn>

      <v-divider
        inset
        vertical
      ></v-divider>

      <v-btn :to="{name: 'Trabajo'}" text>
        Work
      </v-btn>

      <v-divider
        inset
        vertical
      ></v-divider>

      <v-btn :to="{name: 'Contacto'}" text>
        Contact
      </v-btn>

      <v-divider
        inset
        vertical
      ></v-divider>

    </v-toolbar-items>
<v-spacer></v-spacer>
    <router-link to="/"><img src="/img/logo-think.jpg" width="93" height="63"  /></router-link>
     
      

    </v-app-bar>

    <v-main  >
      <v-container style="background-color: #ffffff;"
        class="fill-height"  
        fluid
      >
      <router-view  ></router-view>
      </v-container>
    </v-main>
    
    <v-footer
      color="black"
      app
    >
      <span class="white--text">Think Boutique Creativa &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      sidebar: false,
      menuItems: [
        { path: "/Who-we-are", name: "'Quienes-somos", title: "WHO WE ARE" },
        { path: "/philosophy", name: "Filosofia", title: "PHILOSOPHY" },
        { path: "/services", name: "Services", title: "SERVICES" },
        { path: "/work", name: "Trabajo", title: "WORK" },
        { path: "/contact", name: "Contacto", title: "CONTACT" },
        
      ]
    }),
  }
</script>

<style>
 .textosThink {
         color: white;
         text-align: center;
         background-color: rgba(0, 0, 0, 0.6);
           position: fixed; /* or absolute */
          top: 45%;
          left: 0%;
        }



</style>